/* eslint-disable no-loop-func */
import { useEffect, useContext, useState, useRef } from "react";
import styleAddNewTaxDeclaration from "./AddNewTaxDeclaration.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import stylesModal from "../../../components/UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import UnifiedTaxDeclarationRequestData from "../../../components/UnifiedTaxDeclaration/UnifiedTaxDeclarationRequestData/index";
// import { validateNationalID } from "../../../helpers/Validation";
import { getUnifiedDeclarationAllDetails } from "../../../adapters/apis/lookups/lookups";
import {
  validateRequired,
  validateNationalID,
  validateEgyptianPhoneNumber,
  validateEgyptianPhoneNumberWithPhoneInput,
  validateEmail,
} from "../../../helpers/Validation";
import { previewAndDownloadDeclerationFile } from "../../../adapters/apis/lookups/lookups";

import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import { post, remove, get, put } from "../../../adapters/xhr/api";
import Modal from "react-modal";
import {
  validateBeforeSubmit,
  validatePhoneBeforeSubmit,
} from "../../../components/UnifiedTaxDeclaration/helpers/validationHelper";
import infoIconSvg from "../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../shared/form/InfoPopover";
import BulkUploadDocuments from "../../../components/UnifiedTaxDeclaration/bulkUploadDocuments";

function AddUnifiedTaxDeclaration() {
  Modal.setAppElement("body");
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [tempFiles, setTempFiles] = useState([]);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [pdfMessage, setPdfMessage] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    setDeclarationRequest,
    setIsSubmitting,
    isSubmitting,
    isLoading,
    backendError,
    setBackendError,
    submissionError,
    setSubmissionError,
    error_new_user,
    setNewUserError,
    setError,
    unitOwnerTypeErrorMessage,
    setUnitOwnerTypeErrorMessage,
    validFields,
    setValidFields,
    isBulkUpload,
    setIsBulkUpload,
    bulkdUploadError,
    phoneError,
    setPhoneError,
    getDeclerationDetails,
  } = unifiedTaxDeclarationContext;

  const nationalIdFileInputRef = useRef();
  const passportNumFileInputRef = useRef();
  const commercialRegistrationNumberInputRef = useRef();
  const taxNumberFileInputRef = useRef();
  const otherEntityFileInputRef = useRef();

  const handlePreviewFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclerationFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const sanitizeDeclarationRequest = (newDeclarationRequest) => {
    delete newDeclarationRequest.fixed_installation;
    delete newDeclarationRequest.hotel_facility;
    delete newDeclarationRequest.industrial_facility;
    delete newDeclarationRequest.mine_quarry;
    delete newDeclarationRequest.petroleum_facility;
    delete newDeclarationRequest.production_facility;
    delete newDeclarationRequest.residential_units;
    delete newDeclarationRequest.service_facilities;
    delete newDeclarationRequest.service_units;
    delete newDeclarationRequest.vacant_land;

    if (
      parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
      (declarationRequest?.taxpayer?.phone == "+20" ||
        declarationRequest?.taxpayer?.phone == "20" ||
        declarationRequest?.taxpayer?.phone ===
          declarationRequest?.taxpayer?.dial_code)
    ) {
      newDeclarationRequest.taxpayer.phone = null;
    }
  };

  const handleSubmit = async () => {
    try {
      let newDeclarationRequest = { ...declarationRequest };
      sanitizeDeclarationRequest(newDeclarationRequest);
      setSubmissionError(false);
      setBackendError(false);
      const url = `api/declaration-system/declarations/${id}/submit`;

      setIsSubmitting(true);

      const isValidPhone = validatePhoneBeforeSubmit(
        declarationRequest?.taxpayer?.phone || "20",
        declarationRequest?.taxpayer?.dial_code,
        declarationRequest?.taxpayer?.country_code,
        setPhoneError,
        declarationRequest?.taxpayer?.type_id,
        declarationRequest?.applicant_role_id,
        declarationRequest?.taxpayer?.nationality_id,
      );

      if (declarationRequest?.id && isValidPhone) {
        if (
          parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
          (declarationRequest?.taxpayer?.phone == "+20" ||
            declarationRequest?.taxpayer?.phone == "20" ||
            declarationRequest?.taxpayer?.phone ===
              declarationRequest?.taxpayer?.dial_code)
        ) {
          newDeclarationRequest.taxpayer.phone = null;
        }
        if (parseInt(declarationRequest?.taxpayer?.type_id) === 2) {
          declarationRequest.taxpayer.nationality_id = null;
        }
        declarationRequest.unit = null;
        newDeclarationRequest.unit = null;
        await post(
          url,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          newDeclarationRequest,
        );
        navigate(`/tax-declaration/list-data`);
      }
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      if (error.response?.data?.errors) {
        setSubmissionError(error.response?.data?.errors);
      } else {
        setBackendError(
          error.response?.data?.message ||
            error.response?.data?.data?.message ||
            "خطأ في إرسال البيانات",
        );
      }
      getDeclerationDetails();
      window.scrollTo(0, 0);
    }
  };

  const handleDeleteDeclaration = async () => {
    try {
      setIsSubmitting(true);
      if (id) {
        await post(`api/declaration-system/declarations/${id}/cancel`, {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        });
      }

      if (location?.pathname?.includes("add") && !declarationRequest?.id) {
        await post(
          `api/declaration-system/declarations/declarations/delete-temp-files`,
          {},
          {
            paths: tempFiles,
          },
        );
      }
      navigate("/tax-declaration/list-data", {
        state: { message: "تم إلغاء تقديم الإقرار" },
      });
      setShowModal(false);
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      console.log("failed to delete declaration");
    }
  };

  const handleEditButton = async () => {
    try {
      navigate(`/tax-declaration/update/${declarationRequest?.id}`);
      setDeclarationRequest({
        ...declarationRequest,
        isUnitViewMode: false,
        isUnitEditMode: false,
      });

      if (parseInt(declarationRequest?.status_id) === 2) {
        await post(
          `api/declaration-system/declarations/${id}/status/under-modification`,
          {},
          false,
        );
        let url = `api/declaration-system/declarations/${id}?for_edit=true`;

        if (id) {
          const response = await getUnifiedDeclarationAllDetails(url);

          setDeclarationRequest((prev) => ({
            ...prev,
            ...(response?.data?.data ?? {}),
            activeTab: "residential",
          }));
        }
      }
    } catch (error) {
      console.log("failed to edit decleration");
    }
  };

  const handleSaveDeclaration = async () => {
    try {
      let isValid = true;
      let newDeclarationRequest = { ...declarationRequest };
      sanitizeDeclarationRequest(newDeclarationRequest);

      setSubmissionError(false);
      setBackendError(false);
      if (
        declarationRequest?.taxpayer?.phone !== "" &&
        declarationRequest?.taxpayer?.phone !== null &&
        declarationRequest?.taxpayer?.phone !== undefined &&
        declarationRequest?.taxpayer?.phone !==
          declarationRequest?.taxpayer?.dial_code
      ) {
        if (
          declarationRequest?.taxpayer?.country_code === "eg" &&
          !validateEgyptianPhoneNumberWithPhoneInput(
            declarationRequest?.taxpayer?.phone,
          ) &&
          declarationRequest?.taxpayer?.phone != "+20" &&
          declarationRequest?.taxpayer?.phone != "20"
        ) {
          setError("phone", "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول ");
          setValidFields((prev) => ({ ...prev, phone: false }));
          isValid = false;
        } else {
          setError("phone", "");
          setValidFields((prev) => ({ ...prev, phone: true }));
        }
      }

      if (
        declarationRequest?.taxpayer?.email !== "" &&
        declarationRequest?.taxpayer?.email !== null &&
        declarationRequest?.taxpayer?.email !== undefined
      ) {
        if (!validateEmail(declarationRequest?.taxpayer?.email)) {
          setError("email", "صيغة البريد الالكتروني غير صحيحة ");
          setValidFields((prev) => ({ ...prev, email: false }));
          isValid = false;
        } else {
          setError("email", "");
          setValidFields((prev) => ({ ...prev, email: true }));
        }
      }

      const isFormValid = validateBeforeSubmit(
        declarationRequest,
        validateRequired,
        setValidFields,
        setError,
        validateNationalID,
        setUnitOwnerTypeErrorMessage,
        true,
      );

      const isValidPhone = validatePhoneBeforeSubmit(
        declarationRequest?.taxpayer?.phone || "20",
        declarationRequest?.taxpayer?.dial_code,
        declarationRequest?.taxpayer?.country_code,
        setPhoneError,
        declarationRequest?.taxpayer?.type_id,
        declarationRequest?.applicant_role_id,
        declarationRequest?.taxpayer?.nationality_id,
      );

      if (isFormValid && isValid && phoneError === null && isValidPhone) {
        if (parseInt(declarationRequest?.taxpayer?.type_id) === 2) {
          newDeclarationRequest.taxpayer.nationality_id = null;
        }

        if (
          parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
          (declarationRequest?.taxpayer?.phone == "+20" ||
            declarationRequest?.taxpayer?.phone == "20" ||
            declarationRequest?.taxpayer?.phone ===
              declarationRequest?.taxpayer?.dial_code)
        ) {
          newDeclarationRequest.taxpayer.phone = null;
        }
        setIsSubmitting(true);
        declarationRequest.unit = null;
        newDeclarationRequest.unit = null;

        const url = `api/declaration-system/declarations/${declarationRequest?.id}`;

        const response = await put(
          url,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          newDeclarationRequest,
        );
        setDeclarationRequest((prev) => ({
          ...prev,
          taxpayer: {
            ...prev.taxpayer,
            phone: response?.data?.data?.taxpayer?.phone || "20",
          },
        }));
        setPhoneError(null);
        setError("phone", "");
      }
      setIsSubmitting(false);
    } catch (error) {
      setDeclarationRequest((prev) => ({
        ...prev,
        ...declarationRequest,
      }));
      setIsSubmitting(false);
      if (error.response?.data?.errors) {
        setSubmissionError(error.response?.data?.errors);
      } else {
        setBackendError(
          error.response?.data?.message ||
            error.response?.data?.data?.message ||
            "خطأ في إرسال البيانات",
        );
      }
      window.scrollTo(0, 0);
    }
  };

  const handleSaveAndSubmitDeclaration = async () => {
    try {
      let isValid = true;
      let newDeclarationRequest = { ...declarationRequest };
      sanitizeDeclarationRequest(newDeclarationRequest);
      const url = `api/declaration-system/declarations/${id}/submit`;

      setSubmissionError(false);
      setBackendError(false);
      if (
        declarationRequest?.taxpayer?.phone !== "" &&
        declarationRequest?.taxpayer?.phone !== null &&
        declarationRequest?.taxpayer?.phone !== undefined &&
        declarationRequest?.taxpayer?.phone !==
          declarationRequest?.taxpayer?.dial_code
      ) {
        if (
          declarationRequest?.taxpayer?.country_code === "eg" &&
          !validateEgyptianPhoneNumberWithPhoneInput(
            declarationRequest?.taxpayer?.phone,
          ) &&
          declarationRequest?.taxpayer?.phone != "+20" &&
          declarationRequest?.taxpayer?.phone != "20"
        ) {
          setError("phone", "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول ");
          setValidFields((prev) => ({ ...prev, phone: false }));
          isValid = false;
        } else {
          setError("phone", "");
          setValidFields((prev) => ({ ...prev, phone: true }));
        }
      }

      if (
        declarationRequest?.taxpayer?.email !== "" &&
        declarationRequest?.taxpayer?.email !== null &&
        declarationRequest?.taxpayer?.email !== undefined
      ) {
        if (!validateEmail(declarationRequest?.taxpayer?.email)) {
          setError("email", "صيغة البريد الالكتروني غير صحيحة");
          setValidFields((prev) => ({ ...prev, email: false }));
          isValid = false;
        } else {
          setError("email", "");
          setValidFields((prev) => ({ ...prev, email: true }));
        }
      }
      const isFormValid = validateBeforeSubmit(
        declarationRequest,
        validateRequired,
        setValidFields,
        setError,
        validateNationalID,
        setUnitOwnerTypeErrorMessage,
        true,
      );

      const isValidPhone = validatePhoneBeforeSubmit(
        declarationRequest?.taxpayer?.phone || "20",
        declarationRequest?.taxpayer?.dial_code,
        declarationRequest?.taxpayer?.country_code,
        setPhoneError,
        declarationRequest?.taxpayer?.type_id,
        declarationRequest?.applicant_role_id,
        declarationRequest?.taxpayer?.nationality_id,
      );

      if (isFormValid && isValid && phoneError === null && isValidPhone) {
        if (parseInt(declarationRequest?.taxpayer?.type_id) === 2) {
          newDeclarationRequest.taxpayer.nationality_id = null;
        }

        if (
          parseInt(declarationRequest?.taxpayer?.type_id) === 2 &&
          (declarationRequest?.taxpayer?.phone == "+20" ||
            declarationRequest?.taxpayer?.phone == "20" ||
            declarationRequest?.taxpayer?.phone ===
              declarationRequest?.taxpayer?.dial_code)
        ) {
          newDeclarationRequest.taxpayer.phone = null;
        }
        setIsSubmitting(true);
        declarationRequest.unit = null;
        newDeclarationRequest.unit = null;
        const response = await post(
          url,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
          newDeclarationRequest,
        );
        setDeclarationRequest((prev) => ({
          ...prev,
          taxpayer: {
            ...prev.taxpayer,
            phone: response?.data?.data?.taxpayer?.phone,
          },
        }));
        navigate(`/tax-declaration/list-data`);
      }
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      if (error.response?.data?.errors) {
        setSubmissionError(error.response?.data?.errors);
      } else {
        setBackendError(
          error.response?.data?.message ||
            error.response?.data?.data?.message ||
            "خطأ في إرسال البيانات",
        );
      }
      getDeclerationDetails();
      window.scrollTo(0, 0);
    }
  };

  // const handlePrint = async () => {
  //   try {
  //     setIsSubmitting(true);
  //     const response = await get(
  //       `api/declaration-system/declarations/${id}/pdf`,
  //       {},
  //       false,
  //     );

  //     handlePreviewFile(response?.data?.data?.full_url);
  //     setIsSubmitting(false);
  //   } catch (error) {
  //     setIsSubmitting(false);
  //     console.log("failed to print decleration");
  //   }
  // };

  const handlePrint = async () => {
    try {
      setPdfMessage("");
      setIsSubmitting(true);

      const response = await get(
        `api/declaration-system/declarations/${id}/pdf`,
        {},
        false,
      );

      if (response?.data?.status === "processing") {
        setIsPdfGenerating(true);
        setPdfMessage(response.data.message);
        return;
      }

      if (response?.data?.status === "ready") {
        setPdfMessage("");
        setIsPdfGenerating(false);
        setPdfUrl(response.data.data.full_url);
        handlePreviewFile(response.data.data.full_url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const unitsCount = Number.parseInt(
    declarationRequest?.units_count?.total || 0,
    10,
  );

  const pdfAttachment = declarationRequest?.declaration_pdf;

  const handleCancelClick = () => {
    if (unitsCount < 1) {
      handleDeleteDeclaration();
      return;
    }

    setShowModal(true);
  };

  useEffect(() => {
    if (!isPdfGenerating || pdfUrl) return;

    const interval = setInterval(async () => {
      try {
        const response = await get(
          `api/declaration-system/declarations/${id}/pdf`,
          {},
          false,
        );

        if (response?.data?.status === "ready") {
          setPdfUrl(response.data.data.full_url);
          setPdfMessage("");
          setIsPdfGenerating(false);

          clearInterval(interval);
        } else if (response?.data?.status === "processing") {
          setPdfMessage(response.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [isPdfGenerating, pdfUrl, id]);

  return (
    <MainContent>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            {parseInt(declarationRequest?.status_id) === 2
              ? "سيتم إلغاء الإقرار المُقدم هل أنت متأكد من ذلك؟"
              : " في حالة إلغاء تقديم إقرار سيتم حذف بيانات الإقرار، هل أنت متأكد من القيام ذلك؟"}
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteDeclaration}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showBackModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من العودة إلى القائمة؟ </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={() => navigate(`/tax-declaration/list-data`)}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowBackModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {isBulkUpload ? (
        <>
          {bulkdUploadError && (
            <div
              className="alert alert-danger mt-3 w-75 mx-auto"
              id="backend_error"
              role="alert"
            >
              {bulkdUploadError}
            </div>
          )}
          <BulkUploadDocuments
            styleAddNewTaxDeclaration={styleAddNewTaxDeclaration}
            setValidFields={setValidFields}
          />
        </>
      ) : (
        <>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <section
              className={`${styleAddNewTaxDeclaration["section-content"]} section-content`}
            >
              <div
                className={`${styleAddNewTaxDeclaration.container} container pt-3`}
              >
                {!declarationRequest?.isShowOnlyUnit && (
                  <div className="flex-col d-md-flex  justify-content-between align-items-center flex-row mb-4">
                    <div className="d-flex align-items-center mb-4">
                      <button
                        className={`${styleAddNewTaxDeclaration["btn-arrow"]} ms-3`}
                        onClick={() => {
                          if (
                            location?.pathname?.includes("add") ||
                            location?.pathname?.includes("details")
                          ) {
                            navigate(`/tax-declaration/list-data`);
                          } else {
                            setShowBackModal(true);
                          }
                        }}
                      >
                        <i className="fa-solid fa-arrow-right mt-1"></i>
                      </button>

                      <h3 className="fw-bold m-0 mb-3 mb-md-0">
                        {declarationRequest?.viewMode
                          ? "تفاصيل الأقرار"
                          : declarationRequest?.editMode
                            ? "تعديل بيانات الإقرار"
                            : "تقديم إقرار"}
                      </h3>
                    </div>

                    {declarationRequest?.viewMode ? (
                      <>
                        <div className="d-flex gap-3">
                          {[1, 2, 3].includes(
                            parseInt(declarationRequest?.status_id),
                          ) && (
                            <button
                              onClick={handleEditButton}
                              className={`${styleAddNewTaxDeclaration["btn-request"]}`}
                            >
                              تعديل بيانات الإقرار
                            </button>
                          )}

                          {[2, 4, 5].includes(
                            parseInt(declarationRequest?.status_id),
                          ) && (
                            <button
                              className={`${
                                styleAddNewTaxDeclaration["custom-box"]
                              } px-5 py-3`}
                              onClick={handlePrint}
                              disabled={isPdfGenerating}
                            >
                              {isPdfGenerating ? pdfMessage : "طباعة الإقرار"}
                            </button>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="d-flex flex-column flex-md-row gap-3">
                        {parseInt(declarationRequest?.status_id) === 3 ? (
                          <div className="d-flex flex-column flex-md-row gap-3">
                            <InfoPopover content="يرجى التأكد من دقة البيانات.">
                              <img
                                src={infoIconSvg}
                                alt="info"
                                width="24"
                                height="24"
                                style={{
                                  display: "block",
                                  marginTop: "14px",
                                  marginRight: "16px",
                                }}
                              />
                            </InfoPopover>
                            <button
                              className={` ${
                                parseInt(
                                  declarationRequest?.units_count?.total || 0,
                                ) < 1 ||
                                (!declarationRequest?.data_accuracy_declaration &&
                                  parseInt(
                                    declarationRequest?.status_id !== 1,
                                  )) ||
                                isSubmitting
                                  ? styleAddNewTaxDeclaration[
                                      "submit-btn-disabled"
                                    ]
                                  : styleAddNewTaxDeclaration["submit-btn"]
                              } `}
                              onClick={handleSaveDeclaration}
                            >
                              حفظ{" "}
                            </button>
                            <button
                              className={` ${
                                parseInt(
                                  declarationRequest?.units_count?.total || 0,
                                ) < 1 ||
                                !declarationRequest?.data_accuracy_declaration ||
                                isSubmitting
                                  ? styleAddNewTaxDeclaration[
                                      "submit-btn-disabled"
                                    ]
                                  : styleAddNewTaxDeclaration["submit-btn"]
                              } `}
                              onClick={handleSaveAndSubmitDeclaration}
                            >
                              حفظ و تقديم الإقرار مرة أخرى{" "}
                            </button>
                          </div>
                        ) : (
                          <>
                            {parseInt(declarationRequest?.status_id) === 1 && (
                              <button
                                className={` ${
                                  parseInt(
                                    declarationRequest?.units_count?.total || 0,
                                  ) < 1 ||
                                  !declarationRequest?.data_accuracy_declaration ||
                                  isSubmitting
                                    ? styleAddNewTaxDeclaration[
                                        "submit-btn-disabled"
                                      ]
                                    : styleAddNewTaxDeclaration["submit-btn"]
                                } `}
                                onClick={handleSubmit}
                              >
                                تقديم الإقرار
                              </button>
                            )}
                          </>
                        )}

                        <button
                          className={` ${
                            parseInt(declarationRequest?.status_id) === 1
                              ? styleAddNewTaxDeclaration["cancel-btn"]
                              : (parseInt(
                                    declarationRequest?.units_count?.total || 0,
                                  ) >= 1 &&
                                    parseInt(declarationRequest?.status_id) !==
                                      1) ||
                                  isSubmitting
                                ? styleAddNewTaxDeclaration[
                                    "submit-btn-disabled"
                                  ]
                                : styleAddNewTaxDeclaration["cancel-btn"]
                          } `}
                          onClick={handleCancelClick}
                        >
                          إلغاء الإقرار
                        </button>
                      </div>
                    )}
                  </div>
                )}

                <div
                  className={`${styleAddNewTaxDeclaration["card-box"]} card-box`}
                >
                  <div
                    className={`${styleAddNewTaxDeclaration["box-content"]} box-content`}
                  >
                    <UnifiedTaxDeclarationRequestData
                      nationalIdFileInputRef={nationalIdFileInputRef}
                      passportNumFileInputRef={passportNumFileInputRef}
                      commercialRegistrationNumberInputRef={
                        commercialRegistrationNumberInputRef
                      }
                      taxNumberFileInputRef={taxNumberFileInputRef}
                      otherEntityFileInputRef={otherEntityFileInputRef}
                      validFields={validFields}
                      setValidFields={setValidFields}
                      unitOwnerTypeErrorMessage={unitOwnerTypeErrorMessage}
                      setUnitOwnerTypeErrorMessage={
                        setUnitOwnerTypeErrorMessage
                      }
                      setError={setError}
                      error_new_user={error_new_user}
                      setNewUserError={setNewUserError}
                      handlePreviewFile={handlePreviewFile}
                      backendError={backendError}
                      setBackendError={setBackendError}
                      submissionError={submissionError}
                      setSubmissionError={setSubmissionError}
                      setTempFiles={setTempFiles}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      )}
    </MainContent>
  );
}

export default AddUnifiedTaxDeclaration;
